
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaitonagpurvia() {



    const cardData =
    {
        keyword: 'mumbai to nagpur via samruddhi mahamarg cab service',
        heading: 'Skyline Cabs: mumbai to nagpur via samruddhi mahamarg cab service',
        headingDescription: 'Skyline Cabs offers comfortable and reliable Mumbai to Nagpur Cab Service via Samruddhi Mahamarg for a seamless and efficient journey. Whether you are traveling for business, a spiritual visit, or leisure, our well-maintained vehicles and professional drivers ensure a smooth and enjoyable ride.​',

        top: 'Top Places to Visit in Aurangabad with Skyline Cabs',

"topPlaces": [
    {
        "title": "Deekshabhoomi",
        "description": "A significant pilgrimage site for Buddhists, Deekshabhoomi is where Dr. B.R. Ambedkar converted to Buddhism with thousands of followers. The site has a large stupa and is an important symbol of social justice and equality."
    },
    {
        "title": "Futala Lake",
        "description": "Futala Lake is a popular recreational spot in Nagpur, known for its scenic beauty and tranquility. Visitors can enjoy boating, take a leisurely walk along the lake’s promenade, or relax by the water, especially during the evenings."
    },
    {
        "title": "Nagpur Ramtek Temple",
        "description": "Located on a hilltop, the Ramtek Temple is dedicated to Lord Rama and is an important religious site in Nagpur. The temple offers panoramic views of the surrounding landscape and is a peaceful place for spiritual reflection."
    },
    {
        "title": "Sitabuldi Fort",
        "description": "A historic fort built in the 19th century, Sitabuldi Fort is located in the heart of Nagpur. It played a crucial role in the battle during the British colonial era. The fort is now a symbol of Nagpur’s rich history."
    },
    {
        "title": "Zero Mile Stone",
        "description": "The Zero Mile Stone is the geographical center of India, marking the point from which all distances are measured from Nagpur. The monument is a significant landmark and an interesting stop for tourists interested in geography."
    },
    {
        "title": "Ambazari Lake",
        "description": "One of the largest lakes in Nagpur, Ambazari Lake offers boating opportunities and a peaceful environment for picnics and evening walks. It is surrounded by lush greenery and is a favorite spot for nature lovers."
    },
    {
        "title": "Maharaj Bagh and Zoo",
        "description": "A historical garden and zoo in Nagpur, Maharaj Bagh is home to various animal species and has a well-maintained botanical garden. It’s an ideal spot for families and nature enthusiasts to enjoy wildlife and greenery."
    },
    {
        "title": "Dragon Palace Temple",
        "description": "Located in Kamptee, just outside Nagpur, Dragon Palace Temple is a Buddhist temple known for its unique architecture and serene ambiance. It is a place of worship and meditation, offering a tranquil experience."
    },
    {
        "title": "Krazy Castle Water Park",
        "description": "A popular family destination, Krazy Castle Water Park offers a variety of water rides and recreational activities. It’s a fun spot for both kids and adults to escape the heat and enjoy water-based adventures."
    },
    {
        "title": "Mahalaxmi Temple",
        "description": "An ancient temple dedicated to Goddess Mahalaxmi, this place of worship is an important religious site in Nagpur. The temple attracts devotees for its serene atmosphere and spiritual significance."
    }
],

"services": [
    {
      "name": "Mumbai to Nagpur Samruddhi Mahamarg Cab",
      "description": "Skyline Cabs offers comfortable and reliable cab services from Mumbai to Nagpur via the Samruddhi Mahamarg. Enjoy a smooth and efficient ride on this modern expressway."
    },
    {
      "name": "Mumbai to Nagpur Cab Service",
      "description": "Book a cab for your journey from Mumbai to Nagpur with Skyline Cabs. We provide a safe and comfortable ride with professional drivers."
    },
    {
      "name": "Nagpur Taxi via Samruddhi Mahamarg",
      "description": "Travel from Mumbai to Nagpur via the Samruddhi Mahamarg with Skyline Cabs. Enjoy faster travel with our reliable and timely taxi service."
    },
    {
      "name": "Samruddhi Mahamarg Cab Booking from Mumbai",
      "description": "Book your cab from Mumbai to Nagpur via the Samruddhi Mahamarg with Skyline Cabs. Our booking system is quick and easy, ensuring a hassle-free journey."
    },
    {
      "name": "Mumbai to Nagpur Taxi",
      "description": "Skyline Cabs provides convenient taxi services for your journey from Mumbai to Nagpur. Book a comfortable ride with experienced drivers for a seamless trip."
    }
  ],
  "tableData": [
    ["Mumbai to Nagpur Samruddhi Mahamarg Cab", "Mumbai to Nagpur Cab Service"],
    ["Nagpur Taxi via Samruddhi Mahamarg", "Samruddhi Mahamarg Cab Booking from Mumbai"],
    ["Mumbai to Nagpur Taxi"]
  ],



  whychoose: [
    {
      "WhyChooseheading": "Mumbai to Nagpur via Samruddhi Mahamarg Cab Service",
      "WhyChoosedescription": "Travel faster and more comfortably from Mumbai to Nagpur using the new Samruddhi Mahamarg expressway. Our cab service ensures a smooth, safe, and time-efficient journey along this modern route."
    },
    {
      "WhyChooseheading": "Quick and Efficient Travel via Samruddhi Expressway",
      "WhyChoosedescription": "Experience reduced travel time and a smoother ride thanks to the high-speed Samruddhi Mahamarg. Our cabs are optimized for expressway travel with safety and comfort in mind."
    },
    {
      "WhyChooseheading": "Comfortable, Long-Distance Ready Vehicles",
      "WhyChoosedescription": "Enjoy a relaxing journey in our spacious, air-conditioned cabs that are ideal for long-distance routes like Mumbai to Nagpur."
    },
    {
      "WhyChooseheading": "Professional and Experienced Drivers",
      "WhyChoosedescription": "Our drivers are experienced with the new expressway and long intercity routes, ensuring a safe, smooth, and hassle-free trip to Nagpur."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "We offer competitive rates with clear, upfront pricing and no hidden charges. Travel with peace of mind knowing exactly what you’ll pay."
    },
    {
      "WhyChooseheading": "Well-Maintained and Sanitized Cabs",
      "WhyChoosedescription": "Our vehicles are thoroughly sanitized, regularly maintained, and equipped with modern amenities for hygiene and comfort throughout your journey."
    },
    {
      "WhyChooseheading": "Flexible Booking Options",
      "WhyChoosedescription": "Choose between one-way or round-trip options, with flexible pickup timings to suit your travel schedule from Mumbai to Nagpur."
    },
    {
      "WhyChooseheading": "24/7 Booking and Customer Support",
      "WhyChoosedescription": "Book your cab online or over the phone anytime. Our 24/7 support team is always available to assist with bookings, updates, or any travel-related inquiries."
    }
  ]
  
  
  
  
  
  
  
  
  









    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Mumbai to Nagpur via Samruddhi Mahamarg with Skyline Cabs?',
            answer:
                'Booking your cab with Skyline Cabs is easy. Visit our website, use the mobile app, or call our customer support. Select Mumbai as your pickup point, Nagpur as the destination, and request travel via the Samruddhi Mahamarg expressway for a faster and smoother journey.',
        },
        {
            id: 2,
            question: 'What is the distance and travel time from Mumbai to Nagpur via Samruddhi Mahamarg?',
            answer:
                'The distance from Mumbai to Nagpur via Samruddhi Mahamarg is around 820 km. Travel time has been significantly reduced and now ranges between 11 to 13 hours, depending on the starting point and traffic conditions.',
        },
        {
            id: 3,
            question: 'What vehicles are available for the Mumbai to Nagpur trip?',
            answer:
                'Skyline Cabs offers a wide range of vehicles including Swift Dzire, Ertiga, Kia Carens, Innova Crysta, and premium SUVs. Tempo Travellers and luxury coaches are also available for larger groups.',
        },
        {
            id: 4,
            question: 'Are the cab fares fixed for the Mumbai to Nagpur journey?',
            answer:
                'Yes, our fares are fixed and transparent. The fare includes fuel, driver allowance, tolls, Samruddhi Mahamarg access fees, and taxes. There are no hidden charges, and you’ll get the full fare breakdown before confirming your booking.',
        },
        {
            id: 5,
            question: 'Can I choose to return on a different day or book a round trip?',
            answer:
                'Absolutely. We offer both one-way and round-trip cab bookings from Mumbai to Nagpur. You can schedule a return trip for the same day or choose a later return date based on your convenience.',
        },
        {
            id: 6,
            question: 'Why choose the Samruddhi Mahamarg route?',
            answer:
                'The Samruddhi Mahamarg is a modern expressway that offers a faster, smoother, and safer travel experience. It significantly reduces travel time between Mumbai and Nagpur and offers excellent road conditions throughout the journey.',
        },
        {
            id: 7,
            question: 'Are meals and stopovers available during the trip?',
            answer:
                'Yes, we allow stopovers for meals, restroom breaks, and refreshments. There are well-equipped rest areas and food courts along the Samruddhi Mahamarg.',
        },
        {
            id: 8,
            question: 'What payment methods are accepted?',
            answer:
                'We accept UPI, credit/debit cards, net banking, and cash payments. All online payments are securely processed through verified payment gateways.',
        },
        {
            id: 9,
            question: 'Can I cancel or reschedule my Mumbai to Nagpur cab booking?',
            answer:
                'Yes, Skyline Cabs allows easy rescheduling and cancellations. You can manage your booking through our app, website, or by contacting our support team.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for travel from Mumbai to Nagpur?',
            answer:
                'Skyline Cabs offers professional, reliable, and comfortable cab services. Our experienced drivers, well-maintained vehicles, and commitment to customer satisfaction ensure a stress-free journey across Maharashtra’s finest expressway.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Rohan Pawar",
            rating: 5,
            review: "Booked a Mumbai to Nagpur cab via Samruddhi Mahamarg. What a smooth ride! Driver was very courteous, and the expressway made the trip super quick. Highly recommended for long journeys!"
        },
        {
            name: "Ms. Shweta Bhide",
            rating: 4,
            review: "The journey from Mumbai to Nagpur was great using the new highway. Loved the comfort of the car. Just wish there were more entertainment options inside the vehicle, but overall, excellent service."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Nagpur via Samruddhi Mahamarg Cab",
  "image": "https://skylinecabs.com/assets/images/mumbai-to-nagpur-samruddhi-cab.jpg",
  "description": "Book a cab from Mumbai to Nagpur via Samruddhi Mahamarg with Skyline Cabs for the fastest and most comfortable ride. Travel in AC sedans, SUVs, or luxury cars with verified drivers and fixed pricing—available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7983"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8999",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-to-nagpur-samruddhi-cab"
  }
};


      
      
      

    return (
        <div>

<Helmet>
  <title>Mumbai to Nagpur Cab via Samruddhi Mahamarg | Fast & Reliable Taxi | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book a cab from Mumbai to Nagpur via Samruddhi Mahamarg with Skyline Cabs for the fastest and most comfortable ride. Travel in AC sedans, SUVs, or luxury cars with verified drivers and fixed pricing—available 24/7." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Nagpur Cab, Samruddhi Mahamarg Taxi, Fast Cab Mumbai to Nagpur, Skyline Cabs Mumbai to Nagpur, SUV Taxi Nagpur from Mumbai, Luxury Cab via Samruddhi Mahamarg, One Way Cab to Nagpur, Samruddhi Expressway Cab Booking, AC Sedan Taxi Mumbai Nagpur, 24/7 Taxi Service Mumbai to Nagpur" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/103.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitonagpurvia;